var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._g(_vm._b({staticClass:"bounty-icon-symbol-ref"},'svg',_vm.data.attrs,false),_vm.listeners),[_c('use',{attrs:{"href":"#bounty-icon-symbol"}})])}
var staticRenderFns = []

export { render, staticRenderFns }